exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".close-svg[data-v-748bcd38]{-webkit-filter:invert(40%) sepia(0%) saturate(0%) hue-rotate(115deg) brightness(97%) contrast(89%);filter:invert(40%) sepia(0%) saturate(0%) hue-rotate(115deg) brightness(97%) contrast(89%)}\n", ""]);
